<template>
  <logo-page v-bind="logoPageProps">
    <slot/>
  </logo-page>
</template>

<script>
import BaseUi from '@riseupil/base-ui';
import router from '@/router';

export default {
  name: 'LogoAndBackPage',
  components: {
    LogoPage: BaseUi.Pages.LogoPage,
  },
  props: {
    backgroundColorVariant: {
      type: String,
      required: false,
      validator: value => BaseUi.LayoutConsts.COLOR_VARIANTS.includes(value),
    },
    textColor: {
      type: String,
      required: false,
    },
  },
  computed: {
    logoPageProps() {
      return {
        backgroundColorVariant: this.backgroundColorVariant,
        textColor: this.textColor,
        logoColor: this.textColor,
        actions: [
          {
            type: BaseUi.HeaderActions.BACK,
            onClick: () => (router.canGoBack(this.$route) ? router.back() : this.$router.push({ path: '/sr' })),
          },
        ],
      };
    },
  },
};
</script>

<style scoped>

</style>
